import { DeviceValidated, RegisterDevice } from './model';
import { DeviceRegistrationResultsDto } from '../../../interfaces';
import * as Devices from '../../devices';
import { AppKeys, MessageType, newMsg } from '../../../core/localization';
import { isDevicePKeyWellFormated } from '../../devices';

export const msgBadFormatSN = newMsg(AppKeys.Register_BadFormat_SN_Error);

export const msgBadFormatCode = newMsg(AppKeys.Register_BadFormat_Code_Error);

export const msgDuplicateError = newMsg(AppKeys.Register_Duplicaded_Error);

export const msgRegisterSuccess = (total: number) =>
  newMsg(AppKeys.ApiMykeys_Register_Success, [
    { tag: 'count', value: String(total) },
  ]);

export const mapDeviceValidated = (
  rd: DeviceRegistrationResultsDto
): DeviceValidated => ({
  manufactureId: rd.manufactureId,
  serialNumber: rd.serialNumber,
  message: rd.registrationSucceeded
    ? ''
    : rd.tooManyFailedRegistrationsForUser
    ? newMsg(AppKeys.ApiMykeys_Register_UserBlocked_Error)
    : rd.deviceHasBeenLocked
    ? newMsg(AppKeys.ApiMykeys_Register_DeviceBlocked_Error)
    : rd.serialNumberDoesNotExist
    ? newMsg(AppKeys.ApiMykeys_Register_DeviceNotExists_Error)
    : rd.deviceAlreadyRegistered
    ? newMsg(AppKeys.ApiMykeys_Register_DeviceAlreadyRegistered_Error)
    : rd.availabilityLevelNotSetToExtended
    ? newMsg(AppKeys.ApiMykeys_Register_DeviceNotExtended_Error)
    : rd.serialNumberAndDeviceCodeDoesNotMatch
    ? newMsg(AppKeys.ApiMykeys_Register_DeviceCodeNotMatch_Error)
    : '',
});

export const isDeviceIdWellFormated = (id: Devices.PKey) =>
  isDevicePKeyWellFormated(Devices.getPK(id));

export const isDeviceCodeWellFormated = (code: string) =>
  /^[a-zA-Z0-9]{2}$/.test(code);

export const validateForm = (key: string, code: string, skipBlanks = false) => {
  let errorMsg: MessageType = '';
  if ((!skipBlanks || key) && !isDevicePKeyWellFormated(key)) {
    errorMsg = msgBadFormatSN;
  } else if ((!skipBlanks || code) && !isDeviceCodeWellFormated(code)) {
    errorMsg = msgBadFormatCode;
  }
  return errorMsg;
};

export const validateKeys = (
  keys: RegisterDevice[],
  validatedDevices: DeviceValidated[]
): RegisterDevice[] => {
  return keys.reduce((p: RegisterDevice[], k) => {
    const rdv = validatedDevices.filter(
      (vd) => Devices.getPK(vd) === Devices.getPK(k)
    );
    if (rdv && rdv[0]) {
      rdv[0].message !== '' && p.push({ ...k, errorMsg: rdv[0].message });
    } else {
      p.push(k);
    }
    return p;
  }, []);
};

export const getValidateSucceed = (vds: DeviceRegistrationResultsDto[]) =>
  vds.filter((vd) => vd.registrationSucceeded);
